import DatePicker, {registerLocale} from 'react-datepicker';
import Button from 'react-bootstrap/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Form from 'react-bootstrap/Form';
import {fr} from 'date-fns/locale/fr'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {
    ORDER_SEARCH,
    // ORDER_TYPE_PENDING_SEARCH,
    ORDER_TYPE_TODAY,
    useStoreTransmissions,
} from '../../../store/useStoreTransmissions.ts'

registerLocale('fr', fr);

export const TransmissionsFilters = () => {
    const setType = useStoreTransmissions(state => state.setType);
    const searchText = useStoreTransmissions(state => state.searchText);
    const setSearchText = useStoreTransmissions(state => state.setSearchText);
    const setDateStart = useStoreTransmissions(state => state.setDateStart);
    const setDateEnd = useStoreTransmissions(state => state.setDateEnd);
    const dateStart = useStoreTransmissions(state => state.dateStart);
    const dateEnd = useStoreTransmissions(state => state.dateEnd);
    const resetType = useStoreTransmissions(state => state.resetType);

    function handleSearch(event): void {
        event.preventDefault();
        setType(ORDER_SEARCH)
    }

    function handleChangeSearchText(event): void {
        const {value} = event.target;
        setSearchText(value);

        if (value.length === 0) {
            setType(ORDER_TYPE_TODAY);
        }
    }

    return (
        <Form onSubmit={handleSearch} className={'mb-3'}>
            <Row>
                <Col md={5}>
                    <Form.Group as={Col} controlId={'locality'}>
                        <Form.Label>
                            Localité ou numéro de commande :
                        </Form.Label>
                        <Form.Control
                            type={'text'}
                            placeholder={'Localité ou numéro de commande'}
                            name={'searchTransmissions'}
                            value={searchText}
                            onChange={handleChangeSearchText}
                        />
                    </Form.Group>
                </Col>
                <Col md={2}>
                    <Form.Group as={Col}>
                        <Form.Label>Date de début :</Form.Label>
                        <DatePicker
                            name={'start'}
                            id={'start'}
                            dateFormat={'dd/MM/yyyy'}
                            className={'form-control'}
                            placeholderText={'--/--/----'}
                            openToDate={new Date()}
                            locale={'fr'}
                            showLeadingZeros={true}
                            calendarIcon={null}
                            onChange={setDateStart}
                            selected={dateStart}
                        />
                    </Form.Group>
                </Col>
                <Col md={2}>
                    <Form.Group as={Col}>
                        <Form.Label>Date de fin :</Form.Label>
                        <DatePicker
                            name={'end'}
                            id={'end'}
                            dateFormat={'dd/MM/yyyy'}
                            className={'form-control'}
                            placeholderText={'--/--/----'}
                            openToDate={dateStart ?? new Date()}
                            minDate={dateStart ?? false}
                            locale={'fr'}
                            showLeadingZeros={true}
                            calendarIcon={null}
                            onChange={setDateEnd}
                            selected={dateEnd}
                        />
                    </Form.Group>
                </Col>
                <Col md={3} className={'d-flex align-self-end'}>
                    <div className={'d-flex flex-row'}>
                        <Button
                            type={'submit'}
                            className={
                                'd-flex btn-square align-items-center mr-2'
                            }>
                            <FontAwesomeIcon icon="search" color="white" />
                        </Button>
                        <Button
                            className="btn-red btn-square d-flex align-items-center"
                            onClick={() => resetType()}>
                            <FontAwesomeIcon
                                icon="times"
                                color="white"
                                className="margin-icon"
                            />
                        </Button>
                    </div>
                </Col>
            </Row>
        </Form>
    )
}
